import type { FC, SyntheticEvent } from "react";

import { UiInfoCircleBoldIcon } from "@jti/brand-icons/ui-info-circle-bold";
import { UiInfoCircleSolidIcon } from "@jti/brand-icons/ui-info-circle-solid";

import styles from "./InfoIcon.module.scss";

type InfoIconProps = {
  onClick?: ($event: SyntheticEvent) => void;
  isOpen: boolean;
  size?: "small" | "large";
};

export const InfoIcon: FC<InfoIconProps> = ({ onClick, isOpen, size }) => {
  return (
    <div className={styles.infoIcon} data-size={size}>
      {isOpen ? <UiInfoCircleSolidIcon onClick={onClick} /> : <UiInfoCircleBoldIcon />}
    </div>
  );
};
